<mat-dialog-content>
  <address [model]="model">
  </address>
</mat-dialog-content>

<mat-dialog-actions class="form-actions">
  <forge-button telemetry="Submission-Cancel" variant="outlined" (click)="cancel()">
    Cancel
  </forge-button>

  <forge-button variant="raised" [disabled]="hasErrors" (click)="save()" telemetry="Submission-Save">
    Save
  </forge-button>
</mat-dialog-actions>

@if (isProcessing) {
  <busy-indicator [page]="true"></busy-indicator>
}
